import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import httpForm from "../../../services/http.formdata";
import {
  IAPI_RET005_Request,
  IAPI_RET005_Response,
} from "../../../type/apiType";

// base64 -> Blob
const base64ToBlob = (
  b64Data?: string,
  contentType = "application/octet-stream"
) => {
  if (!b64Data) return null;
  const data = b64Data.includes(",") ? b64Data.split(",")[1] : b64Data;
  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

const buildFormDataFromParam = (param: IAPI_RET005_Request) => {
  const formData = new FormData();
  const { fileList, ...other } = param as any;

  // JSON
  formData.append("request", JSON.stringify(other));

  if (Array.isArray(fileList) && fileList.length) {
    const effectiveList = fileList;

    // base64 を持つファイルを先頭に並べ、multipart の files[] 順と fileMeta[] 順がずれないようにする
    const uniqueFileList = [...effectiveList].sort((a: any, b: any) => {
      const aHasBase64 = Boolean(a.fileBase64 || a.file);
      const bHasBase64 = Boolean(b.fileBase64 || b.file);
      if (aHasBase64 === bHasBase64) {
        return (a.serialNo ?? 0) - (b.serialNo ?? 0);
      }
      return aHasBase64 ? -1 : 1;
    });

    // サーバ側のモデル(ApiRet005FileListModel)が受け取れるプロパティのみを渡すようにする
    const fileMeta = uniqueFileList.map((f: any, idx: number) => {
      const hasFileBase64 = Boolean(f.fileBase64 || f.file);
      if (
        typeof window !== "undefined" &&
        process.env.NODE_ENV !== "production"
      ) {
        console.log("[buildFormDataFromParam] including file for upload:", {
          fileName: f.fileName || f.formName,
          formClass: f.formClass,
          uploadedFlag: f.uploaded,
        });
      }
      const unifiedFileName = f.fileName || f.formName || `file_${idx + 1}`;
      return {
        // serialNo
        serialNo: f.serialNo ?? idx + 1,
        // multipart/files 側に本体を送る対象かどうか
        hasFileBase64,
        // ファイル名
        fileName: unifiedFileName,
        // フォーム区分/種別
        formClass: f.formClass,
        formKbn: f.formKbn,
        // 職員番号
        staffNo: f.fileList_staffNo || f.staffNo,
        // その他
        facilityNo: f.facilityNo,
        issueDate: f.issueDate,
        issueDocumentNo: f.issueDocumentNo,
      };
    });
    formData.append("fileMeta", JSON.stringify(fileMeta));

    // ファイル本体も uniqueFileList を使って追加
    uniqueFileList.forEach((f: any, idx: number) => {
      const b64 = f.fileBase64 || f.file;
      if (!b64) return;
      const blob = base64ToBlob(
        b64,
        f.contentType || "application/octet-stream"
      );
      if (!blob) return;
      const filename = f.fileName || f.formName || `file_${idx + 1}`;
      formData.append("files", blob, filename);
    });
  }

  return formData;
};

const httpAPI_RET005 = async (
  param: IAPI_RET005_Request
): Promise<IAPI_RET005_Response> => {
  const formData = buildFormDataFromParam(param);
  const res = await httpForm.postFormData(ApiUrl.API_RET005, formData);
  return res.data;
};

export { httpAPI_RET005 };
